import {
	authTokenRefreshReducer,
	controlFlagsRootReducer,
	entitlementRootReducer,
	loggedInUserRootReducer,
	orgRootReducer,
	userRootReducer,
	jobListRootReducer,
	navigationRootReducer,
	jobAttachmentsManagerRootReducer,
	fileRootReducer,
	jobDocumentRootReducer,
	attachmentRootReducer,
	jobRelationshipRootReducer,
	appRepairCenterRootReducer
} from '@mitchell/redux.module.apd';
import { Action, combineReducers, Reducer } from 'redux';

class MiRootReducer {
	public root: Reducer<any, Action<unknown> | any>;

	constructor() {
		this.root = combineReducers({
			domain: combineReducers({
				auth: authTokenRefreshReducer,
				controlFlags: controlFlagsRootReducer,
				org: orgRootReducer,
				user: userRootReducer,
				navigation: navigationRootReducer,
				file: fileRootReducer,
				jobDocument: jobDocumentRootReducer,
				attachment: attachmentRootReducer,
				jobRelationship: jobRelationshipRootReducer,
			}),
			app: combineReducers({
				entitlement: entitlementRootReducer,
				loggedInUser: loggedInUserRootReducer,
				jobList: jobListRootReducer,
				jobAttachmentsManager: jobAttachmentsManagerRootReducer,
				repairCenter:appRepairCenterRootReducer	
			}),
		});
	}
}

export const rootReducer = () => new MiRootReducer().root;
